export enum NotificationObjects {
  Stream = 'Stream',
  GDrive = 'GDrive',
}
